import { useEffect, useState } from 'react';
import { Form, ResourceContextProvider, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { FieldValues } from 'react-hook-form';
import _ from 'lodash';
import { useTranslate } from 'ra-core';
import authProvider from '../../../utils/authProvider';
import { typedHttpClient } from '../../../utils/httpClient';
import {
  AppConfigConfigType,
  AppConfigDefinitionType,
} from '../../../lib/constants/typedApiReturnTypes';
import { ClientConfigFormGenerator } from '../../../lib/clientConfigFormGenerator';

export const AppConfigDefaults = () => {

  const [definition, setDefinition] = useState<AppConfigDefinitionType | null>(null);
  const [config, setConfig] = useState<AppConfigConfigType | undefined>();
  const [updateTimestamp, setUpdateTimestamp] = useState<number>(0);
  const notify = useNotify();
  const translate = useTranslate();
  const navigate = useNavigate();
  const isDevAdmin = authProvider.isDeveloperAdmin();

  useEffect(() => {

    if (!isDevAdmin) {

      notify('resources.config.text.no_access');
      navigate(-1);

    }

  }, [isDevAdmin]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {

    typedHttpClient().clientConfig.clientConfigControllerResolveAppDefaultConfigV0().then((response) => {

      setDefinition(response.data.definition);
      setConfig(response.data.config);

    });

  }, [updateTimestamp]);

  const updateConfig = async (values: FieldValues) => {

    if (!definition) {

      return;

    }
    const updatePromises = [];

    for (const def of definition) {

      const originalValue = _.get(config, def.key);
      const newValue = _.get(values, def.key);

      if (!_.isEqual(originalValue, newValue)) {

        if (newValue === null && def.schema['x-optional']) {

          continue;

        }
        if (Array.isArray(newValue)) {

          for (const item of newValue) {

            if (typeof item === 'object') {

              for (const key of Object.keys(item)) {

                if ((item[key] === null || item[key] === undefined) && !def.schema.items?.required?.includes(key)) {

                  delete item[key];

                }

              }

            }

          }

        }

        const id = def.mergeHistory[def.mergeHistory.length - 1].sources[0]._id;
        const updatePromise = typedHttpClient().clientConfig.clientConfigControllerUpdateKey(id, { defaultValue: newValue });
        updatePromises.push(updatePromise);

      }

    }

    const results = await Promise.all(updatePromises);
    const hasError = results.some((result) => result.status >= 400);
    if (hasError) {

      notify('resources.config.text.defaults_update_error', { type: 'error' });

    } else {

      notify('resources.config.text.defaults_updated');

    }
    setUpdateTimestamp(Date.now());

  };

  return (
    <div>
      <h1>{translate('menu.items.app-defaults')}</h1>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ResourceContextProvider value={'ClientConfig'}>
        <Form reValidateMode={'onChange'} record={config} mode="onBlur" onSubmit={updateConfig} sanitizeEmptyValues>
          {definition && <ClientConfigFormGenerator definitions={definition} />}
        </Form>
      </ResourceContextProvider>
    </div>
  );

};
